// StepContext.jsx
import React, { createContext, useContext, useMemo, useState, useCallback, useEffect } from "react";

const StepContext = createContext(null);

export function StepProvider({ children, initialStep = 0, persistKey }) {
  // lazy init + optional persistence
  const [step, setStep] = useState(() => {
    if (persistKey) {
      const v = sessionStorage.getItem(persistKey);
      return v != null ? Number(v) : initialStep;
    }
    return initialStep;
  });

  useEffect(() => {
    if (persistKey) sessionStorage.setItem(persistKey, String(step));
  }, [step, persistKey]);

  const next  = useCallback(() => setStep(s => s + 1), []);
  const prev  = useCallback(() => setStep(s => Math.max(0, s - 1)), []);
  const reset = useCallback(() => setStep(initialStep), [initialStep]);

  const value = useMemo(() => ({ step, setStep, next, prev, reset }), [step, next, prev, reset]);

  return <StepContext.Provider value={value}>{children}</StepContext.Provider>;
}

export function useStep() {
  const ctx = useContext(StepContext);
  if (!ctx) throw new Error("useStep must be used within <StepProvider>");
  return ctx;
}
